import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./utils/config/routes";
import "typeface-roboto";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store/index";
import { PersistGate } from "redux-persist/integration/react";
import Login from "./containers/login";
import UnAuthorizedUser from "./containers/unAuthorizedUser/unAuthorizedUser";

import axios from "axios";
import { storeTokenInSession } from "./utils/common";
// Check if the current path is /login
const isLoginPath = window.location.pathname === "/impersonate/login";

const isJpwDashboardEntry = () => {
  const p = window.location.pathname || "";
  return p === "/jpwdashboard" || p.endsWith("/jpwdashboard");
};

function getAppHomeUrl() {
  const base = String(window.REACT_APP_BASE_URL || "").replace(/\/$/, "");
  const path = window.REACT_APP_HOME_PATH;
  if (!path) {
    return base;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}

/** Normalize API root and avoid .../express/api/express/api when config is wrong. */
function getJpwAuthorizeUrl() {
  let root = String(window.REACT_APP_API_BASE_URL || "")
    .trim()
    .replace(/\/+$/, "");
  root = root.replace(/(\/express\/api)(?:\/express\/api)+$/i, "$1");
  return `${root}/jpw/authorize`;
}

const checkImpersonateStatus = async () => {
  try {
    const response = await axios.get(
      `${window.REACT_APP_ADMIN_APP_URL}/pcaAdmin/api/v1/get-auth-config-details/1`,
    );
    return response.data.content.IS_IMPERSONATE_ENABLE === "Y";
  } catch (error) {
    console.error("Error checking impersonate status:", error);
    return false;
  }
};

// Token-based logic (original logic)
const renderWithTokenLogic = () => {
  const splittedString = window.location.href.split("token=");
  let isContainToken =
    window.location.href.includes("token=") ||
    sessionStorage.getItem("pctoken");

  if (!isContainToken || (splittedString && splittedString[1] === "")) {
    window.location.replace(window.REACT_APP_PARTNER_CENTRAL_HOME_URL);
  } else {
    // sessionStorage.setItem()
    if (!sessionStorage.getItem("pctoken")) {
      storeTokenInSession();
    }
    let isContainUserQuery = window.location.href.includes("authenticated");
    if (!isContainUserQuery) {
      window.location.replace(window.REACT_APP_API_BASE_URL);
    } else {
      // provideToken();
      // storeTokenInSession();

      ReactDOM.render(
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <div className="App">
              <Routes />
            </div>
          </PersistGate>
        </Provider>,
        document.getElementById("root"),
      );
    }
  }
};

// Current logic (without token)
const renderWithoutTokenLogic = async () => {
  if (isLoginPath) {
    // Check impersonate status before rendering login page
    const isImpersonateEnabled = await checkImpersonateStatus();

    if (isImpersonateEnabled) {
      // Render the custom login page without Redux
      ReactDOM.render(
        <div className="App">
          <Login />
        </div>,
        document.getElementById("root"),
      );
    } else {
      // Redirect to base URL if impersonate is not enabled
      window.location.href = `${window.REACT_APP_BASE_URL}`;
    }
  } else {
    // Original SSO login logic with Redux
    let isContainUserQuery = window.location.href.includes("authenticated");
    if (!isContainUserQuery) {
      window.location.replace(window.REACT_APP_API_BASE_URL);
    } else {
      ReactDOM.render(
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <div className="App">
              <Routes />
            </div>
          </PersistGate>
        </Provider>,
        document.getElementById("root"),
      );
    }
  }
};

const renderApp = async () => {
  if (
    window.location.search &&
    window.location.search.includes("jpwUnauthorized=1")
  ) {
    ReactDOM.render(
      <div className="App">
        <UnAuthorizedUser />
      </div>,
      document.getElementById("root"),
    );
    return;
  }

  if (isJpwDashboardEntry()) {
    const queryString = window.location.search
      .replace(/^\?/, "")
      .replace(/(?:\\|%5[Cc])&/g, "&");
    if (!queryString) {
      window.location.replace(`${getAppHomeUrl()}?jpwUnauthorized=1`);
      return;
    }
    const authorizeUrl = getJpwAuthorizeUrl();
    window.location.replace(
      `${authorizeUrl}?userToken=${encodeURIComponent(queryString)}`,
    );
    return;
  }

  // Check if token-based logic should be used based on config
  if (window.TOKEN === "Y") {
    renderWithTokenLogic();
  } else {
    await renderWithoutTokenLogic();
  }
};

// Initialize the app
renderApp();

